import { TextField } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Fragrance } from '~/api/api.declaration';
import { FragranceCreateDto } from '~/shared/dto/admin/fragrance.dto';
import { FragranceId } from '~/shared/dto/id';
import { Concentration, Longevity, Sillage } from '~/shared/dto/model.enums';
import { Form } from '~/shared/form';
import { FieldEnum } from '~/view/fields/field.enum';
import { Col, Row } from '~/view/view.box';
import { FragranceEditReviews } from './fragrance.edit.reviews';

type FragranceImpressionsProps = {
	id: FragranceId;
	form: Form<FragranceCreateDto, Fragrance>;
};

export const FragranceImpressions = observer<FragranceImpressionsProps>(({ id, form }) => {
	return (
		<>
			<Row gap={4}>
				<FieldEnum disabled field={form.$sillage} enumeration={Sillage} enumName="Sillage" nullLabel="" />
				<FieldEnum disabled field={form.$longevity} enumeration={Longevity} enumName="Longevity" nullLabel="" />
			</Row>
			<Row gap={4} alignItems="flex-start">
				<Col>
					<TextField
						multiline
						disabled
						value={form.initial?.occasion
							.sort((a, b) => b.votes - a.votes)
							.map(({ occasion, votes }) => `${occasion}: ${votes}`)
							.join('\n')}
						label="Occasions"
					/>
				</Col>
				<Col>
					<TextField
						multiline
						disabled
						value={form.initial?.weather
							.sort((a, b) => b.votes - a.votes)
							.map(({ weather, votes }) => `${weather}: ${votes}`)
							.join('\n')}
						label="Weathers"
					/>
				</Col>
				<Col>
					<TextField
						multiline
						disabled
						value={form.initial?.season
							.sort((a, b) => b.votes - a.votes)
							.map(({ season, votes }) => `${season}: ${votes}`)
							.join('\n')}
						label="Seasons"
					/>
				</Col>
			</Row>
			<Row gap={4}>
				<FieldEnum
					disabled
					field={form.$concentration}
					enumeration={Concentration}
					enumName="Concentration"
					nullLabel=""
				/>
			</Row>
			{id && <FragranceEditReviews fragranceId={id as FragranceId} />}
		</>
	);
});
